const DOLBY_DIGITAL_REPRESENTATION_CODECS = /* @__PURE__ */ new Set(["ec-3", "ac-3"]);
const CLOSED_CAPTIONS = " [CC]";
const KNOWN_LANGUAGES = /* @__PURE__ */ new Set(["es", "pt", "en"]);
const UNKNOWN_LANGUAGE_ORDER = 1e3;
const TrackLanguageOrder = {
  BR: { pt: 1, en: 2, es: 3 },
  SSLA: { es: 1, en: 2, pt: 3 }
};
const TrackKind = {
  CAPTIONS: /* @__PURE__ */ new Set(["caption", "captions"]),
  SUBTITLE: /* @__PURE__ */ new Set(["subtitle"])
};
const DescriptiveAudio = {
  qad: {
    lang: "qad",
    iso: "pt",
    name: "Portuguese",
    isDescriptive: true
  },
  qae: {
    lang: "qae",
    iso: "es",
    name: "Spanish",
    isDescriptive: true
  },
  qaf: {
    lang: "qaf",
    iso: "en",
    name: "English",
    isDescriptive: true
  }
};
function parseAudioTracks(tracks) {
  return tracks?.map((track) => {
    const [{ id, ...quality }] = track.getQualities();
    const descriptiveInfo = DescriptiveAudio[track.lang];
    const iso = descriptiveInfo?.iso || track.iso;
    const parsedTrack = {
      ...track,
      quality,
      lang: descriptiveInfo?.lang || track.lang,
      iso,
      name: descriptiveInfo?.name || track.name,
      isDescriptive: descriptiveInfo?.isDescriptive || false,
      isDolby: DOLBY_DIGITAL_REPRESENTATION_CODECS.has(quality.codec)
    };
    return {
      ...parsedTrack,
      isAudio: true,
      isUnknown: isLanguageUnknown(parsedTrack)
    };
  });
}
function sortAudioTracks(orderByIso) {
  const compareByIso = tracksComparatorByIso(orderByIso);
  return (tracks) => tracks?.sort((trackA, trackB) => {
    const isoComparison = compareByIso(trackA, trackB);
    if (isoComparison !== 0)
      return isoComparison;
    if (!trackA.isDescriptive && trackB.isDescriptive) {
      return -1;
    }
    if (trackA.isDescriptive && !trackB.isDescriptive) {
      return 1;
    }
    if (!trackA.isDolby && trackB.isDolby) {
      return -1;
    }
    if (trackA.isDolby && !trackB.isDolby) {
      return 1;
    }
    return 0;
  });
}
function tracksComparatorByIso(orderByIso) {
  return (trackA, trackB) => {
    const orderA = orderByIso[trackA.iso] || UNKNOWN_LANGUAGE_ORDER + (trackA.unknownIndex || 0);
    const orderB = orderByIso[trackB.iso] || UNKNOWN_LANGUAGE_ORDER + (trackA.unknownIndex || 0);
    return orderA - orderB;
  };
}
function isLanguageUnknown(track) {
  return !KNOWN_LANGUAGES.has(track.iso);
}
function addIndexToUnknownTracks(tracks) {
  let unknownCount = 0;
  return tracks?.map((track) => {
    if (!track.isUnknown)
      return track;
    unknownCount += 1;
    return {
      ...track,
      isUnknow: true,
      unknownIndex: unknownCount
    };
  });
}
function sortTextTracks(orderByIso) {
  const compareByIso = tracksComparatorByIso(orderByIso);
  return (tracks) => tracks?.sort((trackA, trackB) => {
    const isoComparison = compareByIso(trackA, trackB);
    if (isoComparison !== 0)
      return isoComparison;
    if (!trackA.isClosedCaption && trackB.isClosedCaption) {
      return -1;
    }
    if (trackA.isClosedCaption && !trackB.isClosedCaption) {
      return 1;
    }
    return 0;
  });
}
function parseTextTracks(tracks) {
  return tracks?.map((track) => ({
    ...track,
    isUnknown: isLanguageUnknown(track),
    isClosedCaption: TrackKind.CAPTIONS.has(track?.kind),
    isText: true
  }));
}

var tracks = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CLOSED_CAPTIONS: CLOSED_CAPTIONS,
  DOLBY_DIGITAL_REPRESENTATION_CODECS: DOLBY_DIGITAL_REPRESENTATION_CODECS,
  DescriptiveAudio: DescriptiveAudio,
  KNOWN_LANGUAGES: KNOWN_LANGUAGES,
  TrackKind: TrackKind,
  TrackLanguageOrder: TrackLanguageOrder,
  UNKNOWN_LANGUAGE_ORDER: UNKNOWN_LANGUAGE_ORDER,
  addIndexToUnknownTracks: addIndexToUnknownTracks,
  isLanguageUnknown: isLanguageUnknown,
  parseAudioTracks: parseAudioTracks,
  parseTextTracks: parseTextTracks,
  sortAudioTracks: sortAudioTracks,
  sortTextTracks: sortTextTracks,
  tracksComparatorByIso: tracksComparatorByIso
});

export { CLOSED_CAPTIONS as C, DOLBY_DIGITAL_REPRESENTATION_CODECS as D, KNOWN_LANGUAGES as K, TrackLanguageOrder as T, UNKNOWN_LANGUAGE_ORDER as U, TrackKind as a, DescriptiveAudio as b, tracksComparatorByIso as c, addIndexToUnknownTracks as d, sortTextTracks as e, parseTextTracks as f, isLanguageUnknown as i, parseAudioTracks as p, sortAudioTracks as s, tracks as t };
//# sourceMappingURL=tracks-535cf19f.js.map
